import React, { useState, useEffect } from 'react';
import { connectHits } from 'react-instantsearch-dom';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';
import { getMemberDesignations, getMemberFullName } from '@general/entities/member';

export const List = styled.ul`
    list-style: none;
    position: absolute;
    left: 0;
    top: 75px;
    z-index: 1;
    width: 100%;
    max-height: 385px;
    overflow: scroll;
    margin: 0;
    padding: 0;
    border: 1px solid #d9d9d9;
    border-radius: 5px;
    background-color: #ffffff;
    box-shadow: 0 0 16px 0 rgba(87, 87, 87, 0.2);
`;

export const ListItem = styled.li`
    height: 77px;
    padding: 10px 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    &.browsed-option,
    &:hover {
        background-color: #deebff;
    }
`;

const PropertyContactsSearchHits = ({ hits, onSelect, displayResults }) => {
    const [showList, setShowList] = useState(false);

    const handleSelect = hit => {
        setShowList(false);
        if (onSelect) {
            onSelect(hit);
        }
    };

    useEffect(() => {
        setTimeout(() => {
            setShowList(displayResults);
        }, 100);
    }, [displayResults]);

    return (
        <>
            {showList && (
                <List>
                    {hits.length === 0 && <ListItem>No matches found</ListItem>}
                    {hits.map(hit => (
                        <ListItem key={hit.objectID} onClick={() => handleSelect(hit)}>
                            <div>
                                <p style={{ fontSize: '18px', marginBottom: 0, lineHeight: '1.4em' }}>
                                    {getMemberFullName(hit.first_name, hit.last_name, hit.suffix)}
                                    {hit.designations && <span>{`, ${getMemberDesignations(hit.designations)}`}</span>}
                                </p>
                                <p style={{ fontSize: '14px', marginBottom: 0, color: '#343434' }}>
                                    {hit.member_title || hit.title}
                                    {(hit.member_title || hit.title) && hit.company_name && ', '}
                                    {hit.company_name}
                                </p>
                            </div>
                        </ListItem>
                    ))}
                </List>
            )}
        </>
    );
};

PropertyContactsSearchHits.propTypes = {
    hits: PropTypes.any,
    onSelect: PropTypes.func,
    displayResults: PropTypes.bool,
};

export default connectHits(PropertyContactsSearchHits);
